class LabelFilter{

    /**
     *
     * @param {string} element
     */
    constructor(element){
        this.parent = document.querySelector(element.container);
        if( !this.parent ) return;
        this.loadIn = this.parent.querySelector(element.loadIn);
        this.onclick();
        this.effetmouseover();
    }

    effetmouseover(){
        let _this = this;
        if( !this.parent ) return;
        Array.from(this.parent.querySelectorAll(' .label-item')).map(function(element){
            element.removeEventListener('mouseover', this);
            element.addEventListener('mouseover', function (e){
                _this.parent.querySelector('.circle').style.setProperty('top', `${this.offsetTop}px`);
                _this.parent.querySelector('.circle').style.setProperty('left', `${this.offsetLeft}px`);
            });
        })
    }

    loadPost(filter){
        const xhttp = new XMLHttpRequest();
        let _this = this;
        let params = new FormData();
        params.append('action', 'load_labels');
        params.append('cat', filter);
        params.append('showposts', this.parent.getAttribute('data-showposts'));
        xhttp.onload = function() {
            let response = JSON.parse(this.response);
            _this.loadIn.innerHTML = response.html;
            _this.effetmouseover();
        };
        xhttp.open("POST", WP.ajaxurl);
        xhttp.send(params);
    }

    /**
     *
     * @param {HTMLElement} element
     */
    navbar(element){
        let filter = element.getAttribute('data-filter');
        Array.from(this.parent.querySelectorAll('[data-filter]')).map(function(e){
            e.classList.remove('active');
        });
        Array.from(this.parent.querySelectorAll('[data-filter="'+filter+'"]')).map(function(e){
            e.classList.add('active');
        });
        // element.classList.add('active');
        this.loadPost(filter);
    }

    /**
     *
     */
    onclick(){
        let _this = this;
        if( !this.parent ) return;
        Array.from(this.parent.querySelectorAll('[data-filter]')).map(function(element){
            element.addEventListener('click', function(){
                _this.parent.setAttribute('data-filter', this.getAttribute('data-filter'));
                _this.navbar(this);
                if( !_this.parent.querySelector('.infinite_scroll_loader') && _this.parent.getAttribute('data-infinitescroll') == 'true' ){
                    let div = document.createElement("div");
                    div.classList.add("infinite_scroll_loader");
                    _this.parent.append(div);
                }
            });
        })
    }
}


new LabelFilter({
    container : '.labels-grid',
    loadIn : '.labels-items'
});
